import { Link } from './utils/SmartLink'
import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const TagTemplate = styled.span`
  background: rgba(0,0,0,.1);
  color: black;
  padding: .5rem;
  margin: 2px;
  border: 1px solid rgba(0,0,0,.25);
  display: inline-block;
  border-radius: .33rem;
  white-space: nowrap;
  :hover{
    background: teal;
    color: white;
  }
  :active{
    background: gold;
    color: black;
  }
`

export const TagLink = ({ tag }) => {
  return (
    <Link to={`/tags/${tag}`}><TagTemplate>{tag}</TagTemplate></Link>
  )
}

TagLink.propTypes = {
  tag: PropTypes.string
}
